import { render, staticRenderFns } from "./DefaultMarketingMessageTemplate.vue?vue&type=template&id=5556de64&scoped=true"
import script from "./DefaultMarketingMessageTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultMarketingMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./DefaultMarketingMessageTemplate.vue?vue&type=style&index=0&id=5556de64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556de64",
  null
  
)

export default component.exports